import * as React from "react";
import { Form, Row, Col, Input, Icon, Button, notification } from "antd";
import FormControl from "components/Forms/FormControl";
import { FormComponentProps } from "antd/lib/form";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { EmailConfirmationHandler } from "../EmailConfirmationForm/EmailConfirmationHandler";
import { EmailColLayout, ButtonColLayout, StyleResendEmailConfirmationForm, InputLayout } from "./ResendEmailConfirmation.Style";
import NotificationUtility from "Core/NotificationUtility";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
}

class BaseResendEmailConfirmationForm extends React.Component<Props, State> {
    resendEmailConfirmationHandler: EmailConfirmationHandler;

    constructor(props: Props) {
        super(props)
        this.resendEmailConfirmationHandler = new EmailConfirmationHandler(props)

        this.state = {
        }
    }


    handleResendCode = (e: React.FormEvent) => {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll(['email'], (errors, value) => {
            if (!errors) {
                this.resendEmailConfirmationHandler
                    .ResendConfirmationCode(value.email)
                    .then(() => {
                        NotificationUtility.success('Confirmation code has been resent, kindly check your email.', '', 1000, true);

                        //route to email confirmation page after successfully sending email confirmation token
                        this.props.history.push('/emailconfirmation')
                    })
                    .catch(x => {
                        NotificationUtility.error('An Error Occurred While Resending Confirmation Code.', x.message ?? x, 30, true);
                    });
            }
        });
    };


    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <StyleResendEmailConfirmationForm {...InputLayout}  >
                <Row >
                    <Col >
                        <p className="text">
                            A new token will be sent to your email, please enter the confirmation code provided on the Email Confirmation Screen.
                        </p>
                    </Col>
                </Row>

                <Row type="flex" className="emailFormRow">
                    <Col {...EmailColLayout} className="emailFormCol" >
                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            rules={[{ required: true, message: 'Please enter your email' },
                            { type: 'email', message: 'Please enter a valid email' }]}
                            name="email"
                            // style={{ border: "1px yellow solid", justifyContent: "center", alignItems: "center" }}
                            label="Email">
                            <Input
                                // style={{ border: "1px blue solid", alignSelf: "center" }}
                                prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,0.35)' }} />}
                                size="default"
                            />
                        </FormControl>
                    </Col>
                </Row>
                <Row type="flex" className="resendEmailBtnRow" >
                    <Col {...ButtonColLayout} >
                        <Button
                            className="resendEmailBtn"
                            type="primary"
                            size="default"
                            onClick={this.handleResendCode}>
                            Resend Email Confirmation
                        </Button>
                    </Col>
                </Row>
            </StyleResendEmailConfirmationForm>
        )
    }
}

const BaseResendEmailConfirmationFormWithoutRoute = Form.create<Props>({
    name: 'RegistrationWizard',
})(BaseResendEmailConfirmationForm);

const ResendEmailConfirmationForm = withRouter(BaseResendEmailConfirmationFormWithoutRoute);

export default ResendEmailConfirmationForm;